import { useAnalyticsEvent } from 'monitoring/analyticsHooks';
import {
  DefaultIncomeQuestionComponentProps,
  StepNamesDefaultIncome,
} from 'questionFlow/flows/defaultIncome/types';
import QuestionOrganism from 'questionFlow/QuestionOrganism';
import { useCallback } from 'react';
import { TFunction, useTranslation } from 'react-i18next';

const stepName = StepNamesDefaultIncome.konfirComplete;

const cmsLocation = '/questions/income/KonfirComplete';

const useContent = (t: TFunction<'translation'>) => ({
  title: t(`${cmsLocation}.title`),
  subtitle: t(`${cmsLocation}.subtitle`),
});

const KonfirComplete = ({ data, onSubmit, ...props }: DefaultIncomeQuestionComponentProps) => {
  const { t } = useTranslation();
  const content = useContent(t);
  const { broadcastEvent } = useAnalyticsEvent();

  const handleSubmit = useCallback(() => {
    broadcastEvent('Clicked konfir complete');
    onSubmit({ key: stepName, value: null });
  }, [onSubmit, broadcastEvent]);

  return (
    <QuestionOrganism
      id={stepName}
      data-testid={stepName}
      onSubmit={handleSubmit}
      title={content.title}
      subtitle={content.subtitle}
      isFooterHidden
      {...props}
    >
      {null}
    </QuestionOrganism>
  );
};
export default KonfirComplete;
